
import { TranslationService } from "@/core/services/TranslationService";
import { FormatMethods, getTimeZoneList } from "@/helpers/data-format";
import { ISite } from "@/interfaces/iSite";
import { computed, defineComponent, PropType, toRefs } from "vue";
import VZKeyValue from "@/components/content/VZKeyValue.vue";
import { AddressModel } from "@/interfaces/iCurrentUser";
export default defineComponent({
  name: "site-detail",
  inheritAttrs: false,
  props: {
    data: { type: Object, required: true },
    showCard: { type: Boolean, required: false, default: true },
  },
  components: { VZKeyValue },
  setup(props) {
    const { data } = toRefs(props);
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const format = computed(() => {
      return FormatMethods;
    });

    const getAddress = (address: AddressModel) => {
      if (address == undefined || address == null) return "";
      return (
        address?.street +
        ", " +
        address?.street2 +
        (address?.street2 == "" ? "" : ", ") +
        address.city +
        ", " +
        address.state +
        ", " +
        address.country +
        ", " +
        address.postalCode
      );
    };
    const timeZoneList = computed(() => getTimeZoneList());

    const items = computed(() => {
      const branchTimeZone: any = timeZoneList.value.find(
        (timezone) => timezone.value == data.value?.timezone
      );

      return [
        {
          header: t("common.startDate"),
          value: data.value.startDate
            ? format.value.convertUTCToLocalDate(data.value.startDate)
            : "",
        },
        {
          header: t("common.endDate"),
          value: data.value.endDate
            ? format.value.convertUTCToLocalDate(data.value.endDate)
            : "",
        },
        {
          header: t("pages.site.siteNumber"),
          value: data.value.code,
        },
        {
          header: t("common.siteLevel"),
          value: data.value.typeTextCode,
        },
        {
          header: "Branch Time Zone",
          value: branchTimeZone?.label,
        },
        {
          header: t("common.email"),
          value: data.value.storeEmail,
        },
        {
          header: t("common.address"),
          value: getAddress(data.value.addressModel),
        },
        {
          header: t("pages.site.website"),
          value: data.value.website,
        },
        {
          header: t("common.description"),
          value: data.value.description,
        },
        {
          header: t("common.status"),
          value: data.value.status
            ? format.value.TitleCase(data.value.status?.toLowerCase())
            : "",
          valueClass:
            data.value.status?.toLowerCase() === "active"
              ? "badge badge-success bg-success"
              : "badge badge-danger bg-danger",
        },
        {
          header: t("common.createdDate"),
          value: data.value.createdDate
            ? format.value.convertUTCToLocalDate(
                data.value.createdDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.createdBy"),
          value: data.value.createdBy,
        },
        {
          header: t("common.updatedDate"),
          value: data.value.updateDate
            ? format.value.convertUTCToLocalDate(
                data.value.updateDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.updatedBy"),
          value: data.value.updatedBy,
        },
      ];
    });

    return {
      t,
      format,
      items,
      timeZoneList,
    };
  },
});
